export default [{
	path: 'manage',
	meta: {
		title: '库存'
	},
	component: () => import('@/pages/stock/manage')
}, {
	path: 'in',
	meta: {
		title: '入库'
	},
	component: () => import('@/pages/stock/in')
}, {
	path: 'out',
	meta: {
		title: '退库'
	},
	component: () => import('@/pages/stock/out')
}, {
	path: 'check',
	meta: {
		title: '盘点'
	},
	component: () => import('@/pages/stock/check')
}, {
	path: 'check/create',
	meta: {
		title: '新建盘点单'
	},
	component: () => import('@/pages/stock/check_create')
}, {
	path: 'check/do',
	meta: {
		title: '开始盘点'
	},
	props: route => route.query,
	component: () => import('@/pages/stock/check_do')
}, {
	path: 'check/detail',
	meta: {
		title: '盘点详情'
	},
	props: route => route.query,
	component: () => import('@/pages/stock/check_detail')
}, {
	path: 'allot',
	meta: {
		title: '调拨'
	},
	props: route => route.query,
	component: () => import('@/pages/stock/allot')
}, {
	path: 'rack',
	meta: {
		title: '电子货架-机器上架'
	},
	component: () => import('@/pages/stock/rack')
}]